import React from 'react';
import PartialLoader from '../components/layout/PartialLoader';
import { useSelectedContext } from '../context/contextSelector';
import CoverLoader from '../components/layout/CoverLoader';

const RootLoaders = () => {
  const { coverLoading, coverSecondLoading } = useSelectedContext((context) => context.app);

  return (
    <div>
      <PartialLoader loading={coverLoading} isLightContainer />
      <CoverLoader loading={coverSecondLoading} />
    </div>
  );
};

export default RootLoaders;
